module.exports = __webpack_public_path__ + "static/media/heart.eaa52d1b.svg";